export const SET_MESSAGE_VALUE = "SET_MESSAGE_VALUE";
export const ADD_MESSAGE = "ADD_MESSAGE";
export const POST_MESSAGE = "POST_MESSAGE";
export const POST_DOCUMENT_AS_MESSAGE = "POST_DOCUMENT_AS_MESSAGE";

export const setMessageValue = (value, idCase) => ({
	type: SET_MESSAGE_VALUE,
	value,
	idCase
});

export const addMessage = (message, messageType) => ({
	type: ADD_MESSAGE,
	message,
	messageType
});

export const postMessage = () => ({
	type: POST_MESSAGE
});

export const postDocumentAsMessage = (id) => ({
	type: POST_DOCUMENT_AS_MESSAGE,
	id
});